import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { newSmart, useRouter, useUIComponents, useTranslate, } from "@bluelibs/x-ui";
import { useState, useMemo } from "react";
import { TransactionsAntTableSmart } from "./TransactionsTableSmart";
import { PlusOutlined, FilterOutlined } from "@ant-design/icons";
import * as Ant from "antd";
import { Routes } from "@bundles/UIAppBundle";
import { features } from "../../config/features";
import { TransactionsListFilters } from "./TransactionsListFilters";
import { useAppGuardian } from "@bundles/UIAppBundle/services/AppGuardian";
export function TransactionsList() {
    var _a, _b;
    const { state } = useAppGuardian();
    const UIComponents = useUIComponents();
    const router = useRouter();
    const t = useTranslate();
    const [api, Provider] = newSmart(TransactionsAntTableSmart);
    api.setRoles(((_b = (_a = state === null || state === void 0 ? void 0 : state.user) === null || _a === void 0 ? void 0 : _a.roles) !== null && _b !== void 0 ? _b : []));
    const [filtersOpened, setFiltersOpened] = useState(false);
    const onFiltersUpdate = useMemo(() => {
        return (filters) => {
            api.setFlexibleFilters(filters);
        };
    }, []);
    return (_jsx(UIComponents.AdminLayout, { children: _jsxs("div", Object.assign({ className: "bg-white page-transactions-list" }, { children: [_jsx(Ant.PageHeader, { title: t("management.transactions.list.header"), extra: [
                        features.create ? (_jsx(Ant.Button, Object.assign({ onClick: () => router.go(Routes.TRANSACTIONS_CREATE), icon: _jsx(PlusOutlined, {}, void 0) }, { children: t("management.transactions.list.create_btn") }), "1")) : null,
                        _jsx(Ant.Button, Object.assign({ onClick: () => setFiltersOpened(!filtersOpened), icon: _jsx(FilterOutlined, {}, void 0) }, { children: t("generics.list_filters") }), "2"),
                    ] }, void 0), api.state.isError && (_jsx(Ant.Alert, { type: "error", message: t("generics.error_message") }, void 0)), _jsx(Ant.Layout.Content, { children: _jsx(Provider, { children: _jsxs("div", Object.assign({ className: "page-transactions-list" }, { children: [filtersOpened && (_jsx(TransactionsListFilters, { onUpdate: onFiltersUpdate }, void 0)), _jsx(Ant.Table, Object.assign({}, api.getTableProps()), void 0)] }), void 0) }, void 0) }, void 0)] }), void 0) }, void 0));
}
